export default __webpack_public_path__ + "static/media/gallery-9.d09b69c9.jpg";